import { render, staticRenderFns } from "./SalesAnalysis.vue?vue&type=template&id=d036237c&"
import script from "./SalesAnalysis.vue?vue&type=script&lang=js&"
export * from "./SalesAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports